import API from "../Common/Endpoint/serviceConstrants";
import axiosIntegration from "../Common/Axios/axiosIntegration";
export const callSwitchAccountApi = async (payload) => {
    const { data = {} } = await axiosIntegration.post(API.switchAccountApi, payload);
  return data;
};
